// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1TTp-","col":"Table_col__2JpGn","fulfillmentStatus":"Table_fulfillmentStatus__1Gc6F","emailCol":"Table_emailCol__3n5Zq"};